import { useContext, useEffect, useState } from "react";
import { SinglePDFDropzone } from "../../../main/components/SinglePDFDropzone";
import { pvsystApi } from "../../../services/api";
import { UsinasContext } from "../context/UsinasContextProvider";
import { Box, IconButton, Tooltip } from "@mui/material";
import { PVSystInfoModal } from "./PVSystInfoModal";
import { PVSystToUsina } from "../PVSystMapper";
import { PVSyst } from "../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faTrash } from "@fortawesome/free-solid-svg-icons";
import { ClearPVSystDataConfirmationModal } from "./ClearPVSystDataConfirmationModal";
export function PVSystUpload() {
  const { setPVSyst, pvSyst, newUsina, setNewUsina } =
    useContext(UsinasContext);
  const [file, setFile] = useState<File | null>(null);
  const [openPVSystInfo, setOpenPVSystInfo] = useState(false);
  const [
    openClearPVSystDataConfirmationModal,
    setOpenClearPVSystDataConfirmationModal,
  ] = useState(false);
  const [pvsystError, setPVSystError] = useState(false);
  const sendPVSyst = async (file: File) => {
    if (!file) return;
    setPVSystError(false);
    try {
      const pvSystData = await pvsystApi.postPVSyst(file);
      setPVSyst(pvSystData);
      onConfirmPVSystInfo(pvSystData);
    } catch (error) {
      setPVSystError(true);
      throw error;
    }
  };
  const onConfirmPVSystInfo = (pvSystData: PVSyst) => {
    const usinaDataFromPVSyst = PVSystToUsina(pvSystData);
    if (!usinaDataFromPVSyst) return;
    setNewUsina({
      ...newUsina,
      components: {
        inverters: {
          amount: usinaDataFromPVSyst.components?.inverters?.amount,
          inverterPower:
            usinaDataFromPVSyst.components?.inverters?.inverterPower,
        },
        modules: {
          amount: usinaDataFromPVSyst.components?.modules?.amount,
          power: usinaDataFromPVSyst.components?.modules?.power,
        },
        string: {
          amount: usinaDataFromPVSyst.components?.string?.amount,
        },
      },
      indicators: {
        ...usinaDataFromPVSyst.indicators,
        megaWattValue: newUsina?.indicators?.megaWattValue,
        variance: newUsina?.indicators?.variance,
        efficiency: newUsina?.indicators?.efficiency,
      },
      location: usinaDataFromPVSyst.location,
    });
  };
  const onClearPVSystData = () => {
    setNewUsina({
      ...newUsina,
      indicators: {
        ...newUsina?.indicators,
        efficiency: undefined,
        totalPower: undefined,
        modulesArea: undefined,
        kwPeak: undefined,
        variance: undefined,
        opticalLossesPercentage: undefined,
        conversionLossesPercentage: undefined,
        inverterLossesPercentage: undefined,
        transformerLossesPercentage: undefined,
        irradiance: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        predictedEnergy: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pr: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedOpticalLoss: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedConversionLoss: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedInverterLoss: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedTransformerLoss: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedSystem: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedContractual: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
        pvSystExpectedInverter: {
          jan: undefined,
          feb: undefined,
          mar: undefined,
          apr: undefined,
          may: undefined,
          jun: undefined,
          jul: undefined,
          aug: undefined,
          sep: undefined,
          oct: undefined,
          nov: undefined,
          dec: undefined,
        },
      },
      components: {
        ...newUsina?.components,
        inverters: {
          ...newUsina?.components?.inverters,
          amount: undefined,
          inverterPower: undefined,
        },
      },
      location: {
        latitude: undefined,
        longitude: undefined,
      },
    });
  };
  useEffect(() => {
    if (!newUsina) {
      setPVSyst(null);
      setFile(null);
    }
  }, []);
  const onClear = () => {
    onClearPVSystData(), setPVSyst(null), setFile(null);
  };
  const uploadPVSystLabel = pvsystError
    ? "Erro ao importar arquivo PVSyst. Tente novamente."
    : "Para inserir as informações, importe o arquivo PVSyst ou insira os dados manualmente.";
  return (
    <>
      <Box
        sx={{
          width: "300px",
        }}
        className="d-flex flex-column justify-content-center align-items-center h-100"
      >
        <SinglePDFDropzone
          setUploadedFile={setFile}
          uploadedFile={file}
          label={
            <>
              {uploadPVSystLabel}
              <br /> Clique aqui para importar um arquivo PvSyst
            </>
          }
          height="100px"
          width="100%"
          onUpload={sendPVSyst}
        />
        <Box
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: "8px",
            width: "100%",
          }}
        >
          <Box>
            <Tooltip title="Limpar dados de PVSyst">
              <span>
                <IconButton
                  size="small"
                  disabled={!pvSyst}
                  color="error"
                  onClick={() => setOpenClearPVSystDataConfirmationModal(true)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
          <Box>
            <Tooltip title="Visualizar detalhes do PVSyst">
              <span>
                <IconButton
                  size="small"
                  disabled={!pvSyst}
                  color="primary"
                  onClick={() => {
                    setOpenPVSystInfo(true);
                  }}
                >
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <PVSystInfoModal open={openPVSystInfo} setOpen={setOpenPVSystInfo} />
      <ClearPVSystDataConfirmationModal
        onClear={onClear}
        open={openClearPVSystDataConfirmationModal}
        setOpen={setOpenClearPVSystDataConfirmationModal}
      />
    </>
  );
}
